import { z } from "zod";

/**
 * The outgoing invoices planned to be taken off an incoming invoice's payment, in the order they
 * apply. An empty list takes the plan back.
 */
export const incomingInvoicePlannedOffsetsSchema = z.object({
	outgoingInvoiceIds: z.array(z.uuid()).max(100),
});

export type IncomingInvoicePlannedOffsetsSchema = z.infer<
	typeof incomingInvoicePlannedOffsetsSchema
>;
